import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Contact from '@/components/Contact'
import About from '@/components/About'
import Companies from '@/components/Companies'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '1.618 Space. Комплексное оснащение интерьеров'
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: {
        title: 'Контакты — 1.618 Space'
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        title: 'О подходе — 1.618 Space'
      }
    },
    {
      path: '/companies',
      name: 'Companies',
      component: Companies,
      meta: {
        title: 'Список фабрик — 1.618 Space'
      }
    },
    {
      path: '/',
      redirect: { name: 'Home' }
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.afterEach((to, from) => {
  document.title = to.meta.title;
  document.querySelector('meta[property="og:title"]').setAttribute("content", to.meta.title);
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js